import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import axios from 'axios';

// expectedUpdatedAt: the filing's updatedAt in the version being saved from - the API refuses
// the save (409 FILING_CHANGED) when the filing has been written since.
export default async function setUpdateFiling(filing, projectId, params, expectedUpdatedAt) {
  const apiPath = `filings/${projectId}/update-filing`;

  const body = {
    filing,
    ...(expectedUpdatedAt ? { expectedUpdatedAt } : {}),
  };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    data: body,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
